﻿import { HelmetDexteel } from "@dexteel/mesf-core";
import { MapProvider } from "./context/MapContext";
import { MapComponent } from "./Map";

type Props = {};

const Map = (props: Props) => {
	return (
		<>
			<HelmetDexteel title="Map" />
			<MapProvider>
				<MapComponent />
			</MapProvider>
		</>
	);
};

export default Map;
